/* jshint esversion: 6 */
import { calcInBytes } from "./func.general";

export function validator(completeIds, completeTitle, completeImages, fileSizeKB, schema, selectedRow) {

    let validators = {};

    // eslint-disable-next-line no-unused-vars
    validators.checkArray = function (value, field, model) {
        if (value.length === 0) return [`Bitte wählen Sie mindestens ${field.validatorText} aus.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkBox = function (value, field, model) {
        if (value === false) return [`Bitte wählen Sie ${field.validatorText} aus.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkDate = function (value, field, model) {
        if (value === null || value === '') return [`Bitte geben Sie ${field.validatorText} ein.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkMedienart = function(value, field, model) {
        if (!value) return [`Bitte geben Sie ${field.validatorText} ein.`];
        let findCheck = completeIds.docMediaType.findIndex(element => element.name.toLowerCase() === value.toLowerCase());
        if (findCheck > -1) return['Diese Medienart existiert schon.'];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkDocArea = function(value, field, model) {
        if (!value) return [`Bitte geben Sie ${field.validatorText} ein.`];
        let findCheck = completeIds.docArea.findIndex(element => element.name.toLowerCase() === value.toLowerCase());
        if (findCheck > -1) return['Dieser Bereich existiert schon.'];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkEmail = function (value, field, model) {
        if (value.length === 0) return [`Bitte geben Sie eine E-Mail-Adresse ein.`];
        var strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        var regex = new RegExp(strReg);
        if (regex.test(value) === false) return [`Bitte geben Sie eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkEmailExist = function (value, field, model) {
        let emailCheckArr;
        if (value.length === 0) return [`Bitte geben Sie eine E-Mail-Adresse ein.`];

        var strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        var regex = new RegExp(strReg);
        if (regex.test(value) === false) return [`Bitte geben Sie eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`];

        switch(field.checkMail) {
            case 'docAdvisor': emailCheckArr = completeIds.docAdvisor; break;
            case 'printAgency': emailCheckArr = completeIds.printAgency; break;
            case 'docAgency': emailCheckArr = completeIds.docAgency; break;
        }
        let findCheck = emailCheckArr.findIndex(element => (element.email && element.email.toLowerCase() === value.toLowerCase() || element.mail && element.mail.toLowerCase() === value.toLowerCase()));

        if (findCheck !== -1) return [`Diese E-Mail-Adresse existiert bereits unter dem Namen "${emailCheckArr[findCheck].name}" in der Datenbank.`];

        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkEmailFurther = function (value, field, model) {
        var error = [];
        if (value.length > 0) {
            let valueArr = value.split(',');
            var strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            var regex = new RegExp(strReg);
            valueArr.forEach(emailValue => {
                if (/\s/.test(emailValue.trimStart()) === true) error.push(['whiteSpace', emailValue]);
                if (regex.test(emailValue.trimStart()) === false) error.push(['wrongEmail', emailValue.trimStart()]);
            });
        }

        let errorArr = [];
        error.forEach(element => {
            switch(element[0]) {
                case 'whiteSpace':
                    errorArr.push(`In der E-Mail-Adresse "${element[1]}" befinden sich Leerzeichen`);
                break;
                case 'wrongEmail': 
                    errorArr.push(`Bitte geben Sie bei "${element[1]}" eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`);
                break;
            }
        });
        return errorArr;
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkEmailOrder = function(value, field, model) {
        var error = [];
        if (value.length > 0) {
            let valueArr = value.split(',');
            var strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            var regex = new RegExp(strReg);
            valueArr.forEach(emailValue => {
                if (/\s/.test(emailValue.trimStart()) === true) error.push(['whiteSpace', emailValue]);
                if (regex.test(emailValue.trimStart()) === false) error.push(['wrongEmail', emailValue.trimStart()]);
                if (emailValue.toLowerCase() === model.orderAdvisorMail.toLowerCase()) error.push(['emailExist', emailValue]);
                if (emailValue.toLowerCase() === model.orderReceiverMail.toLowerCase()) error.push(['emailExist', emailValue]);
            });
        }

        let errorArr = [];
        error.forEach(element => {
            switch(element[0]) {
                case 'whiteSpace':
                    errorArr.push(`In der E-Mail-Adresse "${element[1]}" befinden sich Leerzeichen`);
                break;
                case 'wrongEmail': 
                    errorArr.push(`Bitte geben Sie bei "${element[1]}" eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`);
                break;
                case 'emailExist':
                    errorArr.push(`An diese E-Mail-Adresse: ${element[1]} wird schon eine Angebotskopie geschickt`);
                break;
            }
        });
        return errorArr;
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkFileSize = function (value, field, model) {
        if (value) {
            if (fileSizeKB > calcInBytes(field.maxSize)) return ['Die Dateien sind insgesamt zu groß zum versenden. Bitte korrigieren Sie Ihre Auswahl'];
        }
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkFileUpload = function (value, field, model) {
        var error = [];
        let preVersionIndex = schema.fields.findIndex(element => element.model === 'docPreVersion');
        if (model.newFile === true) {
            if (model.files.length === 0) {
                model.docCategory = 0;
                model.docNetLocation = 0;
                model.docInventarNumber = 0;
                model.docVersionNumber = 0;
                model.docPreVersion = false;
                model.docPreVersionFile = [];
                field.hint = '';
                if (model.modelType === 'changeDoc') {                    
                    schema.fields[preVersionIndex].disabled = false;
                    schema.fields[preVersionIndex].visible = false;
                }
                error.push(['noFile', '']);
            } else {
                var appendixArr = ['WEB', 'EDIT', 'PRINT', 'OVN', 'DOCX', 'XLSX', 'PPTX', 'ZIP'];

                //create FileName
                Object.entries(model.files).forEach((valueFile) => {
                    var fileSplit = valueFile[1].split('_');
                    if (fileSplit[fileSplit.length - 1] === 'WEB.pdf') {
                      fileSplit.pop();
                      model.docFileName = fileSplit.join('_');
                    }
                });
  
                var newValArr = model.docFileName.split('_');
                
                var catIndex = completeIds.docCategory.findIndex(element => element.name === newValArr[0]);
                var netIndex = completeIds.docNetLocation.findIndex(element => element.name === newValArr[1]);

                if (catIndex !== -1) model.docCategory = completeIds.docCategory[catIndex].id; else model.docCategory = 0;
                if (netIndex !== -1) model.docNetLocation = completeIds.docNetLocation[netIndex].id; else model.docNetLocation = 0;
                if (!isNaN(newValArr[2])) model.docInventarNumber = newValArr[2]; else model.docInventarNumber = '';
                if (!isNaN(newValArr[3])) model.docVersionNumber = parseInt(newValArr[3]); else model.docVersionNumber = '';
                newValArr.splice(3,1);
                model.docTitleSafe = newValArr.join("_");

                //check for web-pdf
                var proofAppendix = [];
                model.files.forEach((value) => {
                    let fileSplit = value.split('_').pop();
                    proofAppendix.push(fileSplit);
                });
                if (proofAppendix.indexOf('WEB.pdf') === -1) {
                    error.push(['noWeb', '']);
                } else {                    
                    
                    //proof if exists with same versionnumber if new
                    const docTitleArr = model.docFileName.split('_');
                    switch(model.modelType) {
                        case 'newDoc': {
                            let fileSplit = model.docFileName.split('_');
                            let newTitle = fileSplit.splice(0,3).join("_");
                            Object.entries(completeTitle).forEach(element => {
                                let completeTitleSplit = element[1].docFileName.split("_");
                                let existTitle = completeTitleSplit.splice(0,3).join("_");
                                if (newTitle === existTitle) error.push(['fileExist', []]);
                            });
                        }
                        break;
                        case 'changeDoc':
                            if (model.docVersionNumber < selectedRow.docVersionNumber) {
                                if (model.docVersionNumber === 1) {
                                    field.hint = "Achtung. Sie laden die älteste Version des vorhanden Dokuments hoch. Dadurch werden alle neueren Dateien (inklusive der Vorversionen) dieses Dokuments gelöscht.";
                                } else {
                                    field.hint = "Achtung. Sie laden eine ältere Version des vorhanden Dokuments hoch. In diesem Fall müssen Sie auch eine Vorversion hochladen.";
                                    model.docPreVersion = true;
                                    schema.fields[preVersionIndex].disabled = true;
                                    schema.fields[preVersionIndex].visible = true;
                                }
                            } else {
                                field.hint = '';
                                model.docPreVersion = false;
                                schema.fields[preVersionIndex].disabled = false;
                                schema.fields[preVersionIndex].visible = false;
                            }
                        break;
                    }


                    let catIndex = completeIds.docCategory.findIndex(element => element.name === docTitleArr[0]);
                    let netIndex = completeIds.docNetLocation.findIndex(element => element.name === docTitleArr[1]);

                    //in case of edit, same file-name
                    if(model.modelType === 'changeDoc') {
                        if (completeIds.docCategory[catIndex].id !== selectedRow.docCategory) error.push(['falseCat', '']);
                        if (completeIds.docNetLocation[netIndex].id !== selectedRow.docNetLocation) error.push(['falseNetLocation', '']);
                        if (parseInt(selectedRow.docInventarNumber) !== parseInt(docTitleArr[2])) error.push(['falseInventar', '']);
                    }

                    //proof same filename
                    model.files.forEach(element => { 
                        let newElement = element.split('_').slice(0,-1).join('_');
                        if (newElement !== model.docFileName) error.push(['wrongFilename', element]);
                    });

                    //proof other appendix
                    proofAppendix.forEach(element => {
                        let appendixSplitDot = element.split('.');
                        if(!appendixArr.includes(appendixSplitDot[0])) error.push(['wrongAppendix', appendixSplitDot[0]]);
                    });
                    //check filename-convention
                    //whitespaces
                    if (model.docFileName.match(/\s/g)) error.push(['whiteSpace', '']);
                    //special characters
                    if (model.docFileName.match(/[^a-zA-Z0-9_-]+/g)) error.push(['specialChars', '']);
                    //minumum 5 chunks
                    if (docTitleArr.length < 5) error.push(['toShort', '']);
                    //proof first chunk
                    if (catIndex === -1) error.push(['noCategory', docTitleArr[0]]);
                    //proof second chunk
                    if (netIndex === -1) error.push(['noNetLocation', docTitleArr[1]]);
                    //proof third chunk
                    if (isNaN(docTitleArr[2])) error.push(['noInventarNumber', docTitleArr[2]]);
                    //proof forth chunk
                    if (isNaN(docTitleArr[3])) error.push(['noVersionNumber', docTitleArr[3]]);

                    //proof fileType
                    let fileTypeArr = [
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'application/pdf',
                        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'application/zip',
                        'application/x-zip-compressed'
                    ];
                    let fileTypeFind;
                    Object.entries(model.filesUpload).forEach(value => {
                        fileTypeFind = fileTypeArr.indexOf(value[1].type);                
                        if (fileTypeFind === -1) {
                            error.push(['wrongFileType', value[1].name]);
                        }
                        let fileEndArr = value[1].name.split("_");
                        let fileEnd = fileEndArr[fileEndArr.length-1].split(".");
                        switch(fileEnd[0]) {
                            case 'WEB':
                            case 'EDIT':
                            case 'OVN':
                            case 'PRINT':
                                if (value[1].type !== 'application/pdf') error.push(['wrongPDF', value[1].name]);
                            break;
                            case 'DOCX':
                                if (value[1].type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') error.push(['wrongDOCX', value[1].name]);
                            break;
                            case 'PPTX':
                                if (value[1].type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation') error.push(['wrongPPTX', value[1].name]);
                            break;
                            case 'XLSX':
                                if (value[1].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') error.push(['wrongXLSX', value[1].name]);
                            break;
                            case 'ZIP':
                                switch(value[1].type) {
                                    case 'application/zip':
                                    case 'application/x-zip-compressed':
                                    break;
                                    default: 
                                    error.push(['wrongZIP', value[1].name]);
                                }
                            break;
                            
                    
                        }
                    });
                    
                }
            }

            let errorArr = [];
            error.forEach(element => {
                switch(element[0]) {
                    case 'fileExist':
                        errorArr.push('Diese Datei existiert bereits in der Datenbank.');
                    break;
                    case 'falseCat':
                        errorArr.push('Diese Datei stimmt in der Kategorie nicht mit der schon hochgeladenen Datei überein.');
                    break;
                    case 'falseNetLocation':
                        errorArr.push('Diese Datei stimmt im Netzgebiet nicht mit der schon hochgeladenen Datei überein.');
                    break;
                    case 'falseInventar':
                        errorArr.push('Diese Datei stimmt in der Dokumentennummer nicht mit der schon hochgeladenen Datei überein.');
                    break;
                    case 'noWeb':
                        errorArr.push('Sie müssen ein WEB.pdf hochladen.');
                    break;
                    case 'noFile':
                        errorArr.push('Bitte laden Sie mindestens ein WEB.pdf hoch.');
                    break;
                    case 'wrongFilename':
                        errorArr.push('Die Dateinamen stimmen nicht überein.');
                    break;
                    case 'wrongAppendix':
                        errorArr.push(`Der Appendix "${element[1]}" ist nicht erlaubt.`);
                    break;
                    case 'whiteSpace':
                        errorArr.push('Im Dateinamen befinden sich Leerzeichen');
                    break;
                    case 'specialChars':
                        errorArr.push('Im Dateinamen befinden sich Sonderzeichen');
                    break;
                    case 'toShort': 
                        errorArr.push('Der Dateiname entspricht nicht dem Dateibennenungsschema.');
                    break;
                    case 'noCategory':
                        errorArr.push(`Die Sparte "${element[1]}" ist nicht verfügbar.`);
                    break;
                    case 'noNetLocation':
                        errorArr.push(`Das Netzgebiet "${element[1]}" ist nicht verfügbar.`);
                    break;
                    case 'noInventarNumber':
                        errorArr.push(`Die Dokumentennummer "${element[1]}" ist keine Zahl.`);
                    break;
                    case 'noVersionNumber':
                        errorArr.push(`Die Versionsnummer "${element[1]}" ist keine Zahl.`);
                    break;
                    case 'wrongFileType':
                        errorArr.push(`Die Datei "${element[1]}" hat kein gültiges Dateiformat.`);
                    break;
                    case 'wrongPDF':
                        errorArr.push(`Die Datei "${element[1]} ist keine gültige PDF-Datei.`);
                    break;
                    case 'wrongDOCX':
                        errorArr.push(`Die Datei "${element[1]} ist keine gültige Word-Datei.`);
                    break;
                    case 'wrongPPTX':
                        errorArr.push(`Die Datei "${element[1]} ist keine gültige PowerPoint-Datei.`);
                    break;
                    case 'wrongXLSX':
                        errorArr.push(`Die Datei "${element[1]} ist keine gültige Excel-Datei.`);
                    break;
                    case 'wrongZIP':
                        errorArr.push(`Die Datei "${element[1]} ist keine gültige Zip-Datei.`);
                    break;
                }
            });
            return errorArr;
        }
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkFileUploadPix = function(value, field, model) {
        model.thumb = 0;
        model.low = 0;
        model.medium = 0;
        model.imageCategory = 0;
        model.imageName = '';
        model.lowKb = 0;
        model.mediumKb = 0;
        model.thumbKb = 0;
        model.jpg = 0;
        model.svgRot = 0;
        model.svgGrau = 0;
        model.png = 0;
        let errorArr = [];
        let imageNameSplit = '';
        let appendixArr = ['MEDIUM.jpg', 'LOW.jpg', 'THUMB.jpg'];
        let appendixArrSvg = ['THUMB.jpg', 'SVGrot.svg', 'SVGgrau.svg'];
        let appendixArrLogo = ['THUMB.jpg', 'JPG.jpg', 'PNG.png'];
        let appendixArrTeams = ['THUMB.jpg', 'MEDIUM.jpg'];
        let appendixIndex = [];
        if (value) {
            var error = [];
            if (value.length === 0) {
                return ['Sie müssen Dateien hochladen'];
            } else {

                //check for thumb-jpg
                var proofAppendix = [];
                model.files.forEach((value) => {
                    let fileSplit = value.split('_').pop();
                    proofAppendix.push(fileSplit);
                });
                if (proofAppendix.indexOf('THUMB.jpg') === -1) {
                    return ['Sie müssen ein _THUMB.jpg hochladen'];
                } else {
                    model.thumb = 1;

                    //create FileName
                    Object.entries(model.files).forEach((valueFile) => {
                        var fileSplitType = valueFile[1].split('.');
                        if (fileSplitType.length > 2) { 
                            error.push(['dots', '']);
                        }
                        var fileSplit = valueFile[1].split('_');
                        if (fileSplit[fileSplit.length - 1] === 'THUMB.jpg') {
                            fileSplit.pop();
                            model.imageName = fileSplit.join('_');
                        }
                    });
                    imageNameSplit = model.imageName.split('_');

                    switch(model.imageType) {
                        //Fotos
                        case 1:
                            if (imageNameSplit[1]) {
                                if (imageNameSplit[1] !== 'pb') error.push(['secondElement', 'pb']);
                            }

                            var catIndex = completeIds.imageCategory.findIndex(element => element.fileName.toLowerCase() === imageNameSplit[2].toLowerCase());
                            if (catIndex === -1) { 
                                error.push(['category', '']);
                                model.imageCategory = 0;
                            } else {
                                model.imageCategory = completeIds.imageCategory[catIndex].id;
                            }

                            //proof appendix
                            proofAppendix.forEach(element => {
                                appendixIndex = appendixArr.findIndex(elementApp => elementApp === element);
                                if (appendixIndex === -1) error.push(['wrongAppendix', element]);
                            });

                            if (proofAppendix.indexOf('MEDIUM.jpg') === -1)  {
                                error.push(['noMedium', '']);
                            } else {
                                model.medium = 1;
                            }

                            if (proofAppendix.indexOf('LOW.jpg') === -1)  {
                                error.push(['noLow', '']);
                            } else {
                                model.low = 1;
                            }

                            model.filesUpload.forEach(value => {
                                if (value.type !== 'image/jpeg') error.push(['wrongFileTypeJpg', value.name]);
                            });

                        break;
                        //Grafiken
                        case 2:
                            if (imageNameSplit[1]) {
                                if (imageNameSplit[1] !== 'grafik') error.push(['secondElement', 'grafik']);
                            }
                            //proof appendix
                            proofAppendix.forEach(element => {
                                appendixIndex = appendixArr.findIndex(elementApp => elementApp === element);
                                if (appendixIndex === -1) error.push(['wrongAppendix', element]);
                            });

                            if (proofAppendix.indexOf('MEDIUM.jpg') === -1)  {
                                error.push(['noMedium', '']);
                            } else {
                                model.medium = 1;
                            }

                            if (proofAppendix.indexOf('LOW.jpg') === -1)  {
                                error.push(['noLow', '']);
                            } else {
                                model.low = 1;
                            }

                            model.filesUpload.forEach(value => {
                                if (value.type !== 'image/jpeg') error.push(['wrongFileTypeJpg', value.name]);
                            });

                        break;
                        // Icons
                        case 3:
                            if (imageNameSplit[1]) {
                                if (imageNameSplit[1] !== 'icon') error.push(['secondElement', 'icon']);
                            }
                            //proof appendix
                            proofAppendix.forEach(element => {
                                appendixIndex = appendixArrSvg.findIndex(elementApp => elementApp === element);
                                if (appendixIndex === -1) error.push(['wrongAppendix', element]);
                            });
                            if (proofAppendix.indexOf('SVGrot.svg') === -1)  {
                                error.push(['noSVGrot', '']);
                            } else {
                                model.svgRot = 1;
                            }
                            if (proofAppendix.indexOf('SVGgrau.svg') === -1)  {
                                error.push(['noSVGgrau', '']);
                            } else {
                                model.svgGrau = 1;
                            }
                            model.filesUpload.forEach(value => {
                                switch(value.name) {
                                    case `${model.imageName}_SVGrot.svg`:
                                        if (value.type !== 'image/svg+xml') error.push(['wrongFileTypeSVG', value.name]);
                                    break;
                                    case `${model.imageName}_SVGgrau.svg`:
                                        if (value.type !== 'image/svg+xml') error.push(['wrongFileTypeSVG', value.name]);
                                    break;
                                }
                            });
                        break;
                        //Logos
                        case 4:
                            if (imageNameSplit[1]) {
                                if (imageNameSplit[1] !== 'logo') error.push(['secondElement', 'logo']);
                            }
                            //proof appendix
                            proofAppendix.forEach(element => {
                                appendixIndex = appendixArrLogo.findIndex(elementApp => elementApp === element);
                                if (appendixIndex === -1) error.push(['wrongAppendix', element]);
                            });
                            if (proofAppendix.indexOf('JPG.jpg') === -1)  {
                                error.push(['noJpg', '']);
                            } else {
                                model.jpg = 1;
                            }
                            if (proofAppendix.indexOf('PNG.png') === -1)  {
                                error.push(['noPng', '']);
                            } else {
                                model.png = 1;
                            }
                            model.filesUpload.forEach(value => {
                                switch(value.name) {
                                    case `${model.imageName}_PNG.png`:
                                        if (value.type !== 'image/png') error.push(['wrongFileTypePNG', value.name]);
                                    break;
                                    case `${model.imageName}_JPG.jpg`:
                                        if (value.type !== 'image/jpeg') error.push(['wrongFileTypeJPG', value.name]);
                                    break;
                                }
                            });
                        break;
                        case 5:
                            if (imageNameSplit[1]) {
                                if (imageNameSplit[1] !== 'teams') error.push(['secondElement', 'teams']);
                            }
                            //proof appendix
                            proofAppendix.forEach(element => {
                                appendixIndex = appendixArrTeams.findIndex(elementApp => elementApp === element);
                                if (appendixIndex === -1) error.push(['wrongAppendix', element]);
                            });
                            //medium
                            if (proofAppendix.indexOf('MEDIUM.jpg') === -1)  {
                                error.push(['noMedium', '']);
                            } else {
                                model.medium = 1;
                            }
                            model.filesUpload.forEach(value => {
                                if (value.type !== 'image/jpeg') error.push(['wrongFileTypeJpg', value.name]);
                            });
                        break;
                    }
                    //proof file naming
                    if (imageNameSplit[0] !== 'wn') error.push(['firstElement', '']);

                    model.filesUpload.forEach(value => {
                        if (value.name === `${model.imageName}_LOW.jpg`) model.lowKb = value.size;
                        if (value.name === `${model.imageName}_MEDIUM.jpg`) model.mediumKb = value.size;
                        if (value.name === `${model.imageName}_THUMB.jpg`) model.thumbKb = value.size;
                    });

                    if (model.thumbKb > 100000) error.push(['thumbBig', '']); 

                    if (model.imageName.match(/\s/g)) error.push(['whiteSpace', '']);
                    if (model.imageName.match(/[^a-zA-Z0-9_-]+/g)) error.push(['specialChars', '']);

                    // proof if file exists
                    if (model.modelType === 'newImage') {
                        var imageIndex = completeImages.findIndex(element => element.name.toLowerCase() === model.imageName.toLowerCase());
                        if (imageIndex !== -1) error.push(['fileExist', '']);
                    }

                    //proof same filename
                    model.files.forEach(element => { 
                        let newElement = element.split('_').slice(0,-1).join('_');
                        if (newElement !== model.imageName) error.push(['wrongFilename', element]);
                    });

                    error.forEach(element => {
                        switch(element[0]) {
                            case 'dots': 
                                errorArr.push('Im Dateinamen befinden sich mehrere Punkte. Bitte vorher entfernen');
                            break;
                            case 'wrongFileTypeJpg':
                                errorArr.push(`Die Datei ${element[1]} ist keine jpg-Datei`);
                            break;
                            case 'wrongFileTypePNG':
                                errorArr.push(`Die Datei ${element[1]} ist keine png-Datei`);
                            break;
                            case 'wrongFileTypeSVG':
                                errorArr.push(`Die Datei ${element[1]} ist keine svg-Datei`);
                            break;
                            case 'firstElement':
                                errorArr.push('An erster Stelle muss ein "wn" stehen');
                            break;
                            case 'secondElement':
                                errorArr.push(`An zweiter Stelle muss ein "${element[1]}" stehen`);
                            break;
                            case 'category':
                                errorArr.push('Sie haben keine vorhandene Kategorie im Dateinamen genannt, z.B. gas');
                            break;
                            case 'wrongAppendix':
                                errorArr.push(`Der Appendix "${element[1]}" ist nicht erlaubt.`);
                            break;
                            case 'whiteSpace':
                                errorArr.push('Im Dateinamen befinden sich Leerzeichen');
                            break;
                            case 'specialChars':
                                errorArr.push('Im Dateinamen befinden sich Sonderzeichen');
                            break;
                            case 'noMedium':
                                errorArr.push('Es fehlt eine _MEDIUM.jpg Datei');
                            break;
                            case 'noLow':
                                errorArr.push('Es fehlt eine _LOW.jpg Datei');
                            break;
                            case 'noSVGrot':
                                errorArr.push('Es fehlt eine rote _SVGrot.svg Datei');
                            break;
                            case 'noSVGgrau':
                                errorArr.push('Es fehlt eine grau _SVGgrau.svg Datei');
                            break;
                            case 'fileExist':
                                errorArr.push('Diese Datei existiert bereits in der Datenbank.');
                            break;
                            case 'wrongFilename':
                                errorArr.push('Die Dateinamen stimmen nicht überein.');
                            break;
                            case 'thumbBig':
                                errorArr.push('Das Thumb darf nicht mehr als 100 kb Dateigröße haben.');
                            break;
                            case 'falseSizeWidth': 
                                errorArr.push('Das Thumb muss eine Breite von 500 px haben.');
                            break;
                            case 'falseSizeHeight': 
                                errorArr.push('Das Thumb muss eine Höhe von 333 px haben.');
                            break;
                        }
                    });

                    model.proofThumb = true;
                    return errorArr;
                }
            }
        }
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkFileUploadPreVersion = function(value, field, model) {
        if (value.length === 0) return ['Bitte wählen Sie eine Datei aus'];
        if (model.docFileName === '') return ['Bitte laden Sie zuerst die Hauptdateien hoch'];
        let valueArr = value[0][0].name.split("_");
        if (parseInt(valueArr[3]) === parseInt(model.docVersionNumber)) return ['Es handelt sich bei dieser Datei um die gleiche Version der Hauptdatei. Diese müssen aber verschieden sein.'];
        if (parseInt(valueArr[3]) > parseInt(model.docVersionNumber)) return ['Die Vorversion muss kleiner als die Hauptversion sein'];
        if (valueArr.indexOf('WEB.pdf') === -1) return ['Die Datei muss ein _WEB.pdf sein'];
        valueArr.splice(3,1);
        valueArr.pop();
        let docTitle = model.docTitleSafe.split("_");
        if ((docTitle[0] !== valueArr[0]) || (docTitle[1] !== valueArr[1]) || (docTitle[2] !== valueArr[2])) return ['Die Datei passt nicht zur Hauptdatei'];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkInput = function (value, field, model) {
        if (!value || value === '') return [`Bitte geben Sie ${field.validatorText} ein.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkPassword = function (value, field, model) {
        if (value.length === 0) return [`Bitte geben Sie ein Passwort ein.`];
        if (value.length < 8) return [`Das Passwort ist zu kurz. Bitte mindestens 8 Zeichen verwenden.`];
        if (!value.match(/[A-Z]{1,}/)) return [`Das Passwort muss mindestens einen Großbuchstaben enthalten.`];
        if (!value.match(/\W/)) return [`Das Passwort muss mindestens ein Sonderzeichen enthalten.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkPassword2 = function (value, field, model) {
        if (model.password !== model.password2) return [`Die Passwörter stimmen nicht überein.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkPLZ = function (value, field, model) {
        if (value.length === 0) return [`Bitte geben Sie ${field.validatorText} ein.`];
        if (isNaN(value)) return [`Dies ist keine Zahl.`];
        if (value.length > 5) return [`Eine Postleitzahl darf nicht mehr als 5 Zahlen beinhalten.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkPrintPages = function (value, field, model) {
        if (model.showPrintValues === 1) {
            if (!value) return [`Bitte geben Sie ${field.validatorText} ein.`];
            if (isNaN(value)) return ['Diese Angabe muss eine Zahl sein.'];
        }
        return [];
    };
    
    // eslint-disable-next-line no-unused-vars
    validators.checkPrintFile = function (value, field, model) {
        if (parseInt(value) === 0) return [`Bitte wählen Sie ${field.validatorText} aus.`];
        var findValue = field.values.findIndex(s => s.id === value);
        var printStatus = field.values[findValue].printStatus;
        if (parseInt(printStatus) === 1 && parseInt(model.print) === 0) {
            return ['Sie müssen bei dieser Auswahl ein Print-PDF hochladen.'];
        }
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkRequestFile = function(value, field, model) {
        if (value.length > 0) {
            //check filetype
            let fileTypeArr = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            ];

            let fileTypFind = fileTypeArr.indexOf(value[0][0].type);
            if (fileTypFind === -1) return ['Diese Datei hat nicht das erlaubte Dateiformat'];

            //check filesize
            if (value[0][0].size > calcInBytes(field.maxSize)) return ['Die Datei ist zu groß'];
        }
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkSelect = function (value, field, model) {
        if (parseInt(value) === 0) return [`Bitte wählen Sie ${field.validatorText} aus.`];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkSignature = function(value, field, model) {
        if (parseInt(value) === 0) return [`Bitte wählen Sie ${field.validatorText} aus.`];
        if ((value === model.sender) && (!sessionStorage.getItem('wnPortal_signature'))) return ['Bitte legen Sie zuerst eine eigene Signatur an'];
        return [];
    };

    // eslint-disable-next-line no-unused-vars
    validators.checkWeight = function (value, field, model) {
        if (model.showPrintValues === 1) {
            if (!model.paramWeightGeneral && !model.paramWeightContent && !model.paramWeightCover) return [`Bitte geben Sie mindestens ein Gewicht ein.`];
            if (model.paramWeightGeneral && (model.paramWeightContent || model.paramWeightCover)) return ['Wenn Sie ein allgemeines Papiergewicht angegeben haben, dürfen Sie kein Papiergewicht für Umschlag oder Innenteil angeben.'];
            if (!model.paramWeightGeneral && (!model.paramWeightContent || !model.paramWeightCover)) return ['Wenn Sie ein Gewicht für den Umschlag oder Innenteil eingeben, müssen Sie auch das andere Feld für Umschlag oder Innenteil ausfüllen und das Feld Papiergewicht leer lassen'];
        }
        return [];
    };   


    // eslint-disable-next-line no-unused-vars
    validators.checkWnUpdate = function(value, field, model) {
        if (model.wnWebsite === true) {
            if (model.newFile === false) {
                if (model.wnWebsiteUpdate === false) {
                    return ['Sie müssen dafür zunächst neue Dateien hochladen oder falls dieses Dokument auf wesernetz.de schon vorhanden ist, den Schalter entsprechend umlegen und die Sitecore-Id eintragen'];
                }
            }
        }
        return [];
    };

    return validators; 
}
